import { qualifySelector } from "../utils";

function reducer(
  // If this default argument value is defined before the function declaration
  // in a variable and referred from there, the reducer will not pick up initial
  // window.onecomConfig settings in test files, because the file already loaded
  // with `null` before the reducer would have been used during rendering:
  state = window && window.onecomConfig ? window.onecomConfig : null,
) {
  return state;
}

export const name = "onecomConfig";
export default { [name]: reducer };

//export const isCountrySpain = qualifySelector(name, state => state.countryCode === "ES");
export const getOnecomConfig = qualifySelector(name, (state) => state);
